import { Box } from '@chakra-ui/react';
import moment from 'moment';

import { TextRegular } from 'UiKit/typography';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import ActionButton from 'View/brief-live/component/action-button';
import StatusBadge from 'View/brief-live/component/status-badge';
import TitleColumn from 'View/brief-live/component/talking-point-columns/title-column';

import { getPublishStatus, getTalkingPointStatuses } from './statusConfig';

import styles from './styles.module.css';

const tableListTalkingPoint = ({ t }) => {
  const accessPermission = getMenuPermissions('others', 'briefs');

  const tableList = [
    {
      name: t('tableTalkingPoint.timeCreated'),
      width: 150,
      key: 'createdAt',
      sortKey: 'createdAt',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value ? moment(value).format('DD MMM YY HH:mm') : '-'}</TextRegular>,
    },
    {
      name: t('tableTalkingPoint.startTime'),
      width: 150,
      key: 'startTime',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value ? moment(value).format('DD MMM YY HH:mm') : '-'}</TextRegular>,
    },
    {
      name: t('tableTalkingPoint.endTime'),
      width: 150,
      key: 'endTime',
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value ? moment(value).format('DD MMM YY HH:mm') : '-'}</TextRegular>,
    },
    {
      name: t('tableTalkingPoint.title'),
      width: 352,
      key: 'title',
      component: ({ value, values }) => <TitleColumn value={value} values={values} />,
    },
    {
      name: t('tableTalkingPoint.draftStatus'),
      width: 120,
      key: 'isPublished',
      component: ({ value }) => (
        <Box className={styles['column__text']}>
          <StatusBadge {...(getPublishStatus({ t, isPublished: value }) || {})} />
        </Box>
      ),
    },
    {
      name: t('tableTalkingPoint.status'),
      width: 100,
      key: 'status',
      component: ({ value }) => (
        <Box className={styles['column__text']}>
          <StatusBadge {...(getTalkingPointStatuses({ status: value, t }) || {})} />
        </Box>
      ),
    },
  ];

  if (accessPermission?.isCanEdit || accessPermission?.isCanDelete) {
    tableList.push({
      name: t('tableTalkingPoint.action'),
      key: 'action',
      width: 120,
      position: 'center',
      component: ({ values }) => <ActionButton values={values} accessPermission={accessPermission} />,
    });
  }

  return tableList;
};

export default tableListTalkingPoint;
